import { FC, useRef, useState, useEffect, useContext, forwardRef, useImperativeHandle } from 'react';
import { Button, Image } from 'antd';
// import V2Title from '@/common/components/Feedback/V2Title';
import V2Table from '@/common/components/Data/V2Table';
import { V2Confirm } from '@/common/components/Others/V2Confirm';
import V2Empty from '@/common/components/Data/V2Empty';
import V2Operate from '@/common/components/Others/V2Operate';
import V2Message from '@/common/components/Others/V2Hint/V2Message';
import { isArray, isNotEmpty, isNotEmptyAny, refactorPermissions } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import styles from '../index.module.less';
import cs from 'classnames';
import ChancePointDetail from '@/common/components/business/ExpandStore/ChancePointDetail';
import ChanceCreateDrawer from '@/common/components/business/ExpandStore/ChanceCreateDrawer';
import SelectTemplateModal from '@/common/components/business/ExpandStore/ChanceCreateDrawer/SelectTemplateModal';
import { checkApprovalForm, passStandardChancepoint, taskChancePointInfo } from '@/common/api/expandStore/expansiontask';
import { getTemplateLists } from '@/common/api/expandStore/chancepoint';
import { approvalTemplateList } from '@/common/api/approvalflow';
import CreatePointMatching from './CreatePointMatching';
import CreateSpotApproval from '@/common/components/business/ExpandStore/TaskDetailCommon/CreateSpotApproval';
import ApproverDetailDrawer from '@/views/expandstore/pages/approver/components/DetailDrawer';
import ReleaseChance from '@/common/components/business/ExpandStore/ReleaseChance';
import {
  ProtectStatusColor,
  ProtectString,
  ChancePointStatusColor,
  ApprovalStatus,
  ApprovalType,
  ApprovalTypeValue
} from '@/common/components/business/ExpandStore/ts-config';
// import ContractSignModal from '@/views/expandstore/pages/shop/components/ContractSignModal';
// // import { bigdataBtn } from '@/common/utils/bigdata';
import ShopEditDrawer from '@/views/expandstore/pages/shopEdit/Drawer';
import { useBigdataFn } from '@/common/utils/bigdata';
import AreaProtectionDrawer from '@/common/components/business/AreaProtection/detail';
import UserInfoContext from '@/layout/context';
import { ShopEditType } from '@/views/expandstore/pages/shopEdit/ts-config';
import { decodeTextValue } from 'src/common/components/business/StoreDetail/components/DynamicDetail/config';
// import { addressIdentification } from '@/common/components/business/DynamicComponent/customize';

/**
 * 拓店任务-详情-点位匹配情况
 * @Description
 * 拓店任务：直营-详情
 * 拓店任务：森马（参考clusterA直营）
 *
 * 目前看来卡旺卡和普通拓店任务处理的差异：modelClusterId参数
 */
const PointMatching: FC<{
  /** 任务ID */
  id: number;
  modelClusterId: number;
  // modelClusterInfo: any;
  /** 匹配点位信息 */
  chancePointInfo: any;
  /** 设置机会点数据 */
  setChancePointInfo:Function;
  /** 是否只能查看（审批详情时只能查看） */
  isView: boolean;
  /** 外部新增按钮是否可见 */
  showAddBtn?: boolean;
  refresh: any;
  chancepointAlias?: string;
  hideOperate?: boolean;
  /** 提供给：clusterC 拓店任务：森马，clusterA 直营 */
  providerFor?: string,
  /** 展示外部的新增机会点按钮文案，为空则不展示按钮 */
  setAddPointButtonText?: any,
  ref?: any,
}> = forwardRef(({
  id,
  modelClusterId,
  // modelClusterInfo,
  chancePointInfo,
  isView,
  showAddBtn = true,
  setChancePointInfo,
  refresh,
  chancepointAlias,
  hideOperate, // 是否不可以点击查看详情(防止套娃)
  providerFor = 'clusterA',
  setAddPointButtonText,
}, ref) => {

  useImperativeHandle(ref, () => ({
    addChancePoint: methods.handleCreatePointMatching,
  }));

  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const editRef: any = useRef();
  const createPointMatchingRef: any = useRef();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [filters, setFilters] = useState<any>(); // 筛选参数
  const [showCreateModal, setShowCreateModal] = useState<boolean>(false); // 是否显示新建弹窗
  const [selectTemplateVisible, setSelectTemplateVisible] = useState<boolean>(false);
  const [templateList, setTemplateList] = useState<any[]>([]);
  const [pointId, setPointId] = useState<number>(); // 机会点id
  const [showPointDetail, setShowPointDetail] = useState<boolean>(false); // 是否显示机会点详情弹窗
  const [areaProtectOpen, setAreaProtectOpen] = useState<boolean>(false);// 发起保护
  const [refreshDetail, setRefreshDetail] = useState<number>(0); // 刷新机会点详情
  const [formDrawerData, setFormDrawerData] = useState<any>({
    open: false,
    templateId: '', // 模板id
    id: '', // 编辑时的id
  }); // 机会点详情上的编辑
  const [drawerData, setDrawerData] = useState<any>({
    open: false,
    templateId: '', // 模板id
    id: '', // 编辑时的id
    expandStoreData: null, // 拓店任务相关信息
  }); // 完善点位评估编辑
  const [releaseData, setReleaseData] = useState<any>({
    open: false,
    id: '', // 解除绑定时的任务id
  }); // 解除绑定弹窗
  const [approvalModal, setApprovalModal] = useState<any>({
    show: false,
    id: undefined, // 机会点ID
    type: undefined, // 审批类型
    typeValue: undefined, // 审批子类
  }); // 提交审批弹窗
  const [contractApprovalData, setContractApprovalData] = useState<any>({
    id: null,
    open: false,
  }); // 合同签约审批详情
  const [enableSpotApproval, setEnableSpotApproval] = useState<boolean>(true); // 点位评估审批流是否打开，目前使用中仅森马关闭
  // const [signVisible, setSignVisible] = useState(false); // 合同签约弹窗
  const { tenantInfo } = useContext(UserInfoContext); // 租户信息

  /**
   * @description 是否启用机会点与任务自动关联
   *  加盟商拓店模板A:
   *    益禾堂租户的有址选址任务类型，特殊处理为添加机会点后自动关联；其他都为手动关联
   *  直营模板、直营+加盟模板:
   *    这两套任务模板下，最早都是按照是否位于开店区域内来自动关联，24/12/27卡旺卡租户希望使用手动关联方式，所以增加了配置，可控制是否自动关联。
   *
   *   区别，自动关联时展示“添加机会点”，手动关联时展示“关联机会点”
   */
  const isAutoRelate = tenantInfo?.taskAutoAssociatePointEnable;

  /**
   * @description 添加文案，与是否自动关联及别名有关
   */
  const addText = (isAutoRelate ? '新增' : '关联') + chancepointAlias;

  /**
   * @description 是否仅允许关联审批通过的机会点
   *
   *  租户设置了仅可关联审批过的机会点
   */
  const onlyApprovedChance = !!tenantInfo?.onlyAllowRelatedApprovalPoint;

  /**
   * @description 是否可以手动解除绑定机会点
   *
   * 需要满足：
   *  可操作场景（审批详情、或者拓店任务状态非进行中时不可操作）
   *  点位和任务自动关联，设置为OFF
   */
  const canManualRelease = !isView && !isAutoRelate;

  /** 展示内部列表上方的新增按钮 */
  const showInnerAddButton = !isView && showAddBtn && !!chancePointInfo?.objectList?.length;

  useEffect(() => {
    getTemplateLists().then((result) => {
      setTemplateList(result.map((item) => ({ label: item.templateName, value: item.id })));
    });
    methods.loadApprovalTemplates(); // 事先读取审批模板
  }, []);
  useEffect(() => {
    // 为了和内部显示逻辑统一
    setAddPointButtonText?.(chancePointInfo?.objectList?.length ? addText : '');
  }, [chancePointInfo?.objectList, addText]);

  /**
   * @description 机会点创建带入地址字段、地址会自动带出开店区域信息
   * @return
   */
  // const assignedChanceData = useMemo(() => {
  //   if (!isNotEmptyAny(modelClusterInfo)) return [];

  //   const {
  //     centerLng: lng,
  //     centerLat: lat,
  //     modelClusterName: name,
  //   } = modelClusterInfo;
  //   const params: any[] = [];
  //   if (+lng && +lat && name) {
  //     const basicAddress = {
  //       identification: addressIdentification,
  //       textValue: JSON.stringify({
  //         address: name,
  //         longitude: lng,
  //         latitude: lat,
  //         poiName: name
  //       })
  //     };
  //     params.push(basicAddress);
  //   }
  //   return params;
  // }, [modelClusterInfo]);

  /** 基础列 */
  const basicColumns = [
    {
      key: 'shopImgUrls',
      title: '点位图片',
      width: 100,
      dragMinWidth: 100,
      dragChecked: false,
      noTooltip: true,
      render: (value) => <Image
        className={styles.img}
        src={isArray(value) && value.length
          ? value?.[0]
          : 'https://staticres.linhuiba.com/project-custom/locationpc/task/ic_place_noimg.png'}
      />
    },
    {
      key: 'name',
      title: '点位名称',
      width: 'auto',
      dragChecked: true,
      render: (value, record) => {
        return isNotEmptyAny(value) ? (
          <span
            // className={!isView ? styles.highlight : ''}
            className={hideOperate ? '' : styles.highlight}
            onClick={() => methods.onClickDetail(record)}
          >
            {value}
          </span>
        ) : (
          '-'
        );
      },
    },
    {
      key: 'address',
      title: '详细地址',
      width: 380,
      importWidth: true,
      dragChecked: true,
      render: (value) => isNotEmptyAny(value) ? value : '-',
    },
    {
      key: 'statusName',
      title: '状态',
      width: 'auto',
      dragChecked: true,
      render: (value, record) => isNotEmptyAny(value) ? <span
        style={{
          color: ChancePointStatusColor[record?.status]
        }}
      >{value}</span> : '-',
    },
    // {
    //   key: 'process',
    //   title: '填写进度',
    //   width: 'auto',
    //   render: (value, record) => (
    //     <>
    //       <Progress
    //         percent={record.requiredNum / record.requiredTotalNum * 100}
    //         showInfo={false}
    //         trailColor='#ddd'
    //         style={{
    //           width: '64px',
    //           marginRight: 8
    //         }}/>
    //       {record.requiredNum}/{record.requiredTotalNum}
    //     </>
    //   )
    // },
  ];

  /** 保护状态 */
  const protectColumn = {
    key: 'protectStatusName',
    title: '保护状态',
    width: 'auto',
    dragChecked: true,
    render: (value, record) => {
      const protectStatusName = record?.protectInfo?.statusName;
      if (isNotEmptyAny(protectStatusName)) {
        return <span style={{
          color: ProtectStatusColor[protectStatusName] || '#666666'
        }}>{protectStatusName}</span>;
      } else {
        // 区域保护可用时，显示未保护，否则显示-
        const canApplyProtect = isArray(record?.processButton) && !!record?.processButton.find((itm: any) => itm.code === 'standardChancePoint:submitProtect');
        return canApplyProtect ? <span style={{
          color: ProtectStatusColor[ProtectString.Off]
        }}>{ProtectString.Off}</span> : '-';
      };
    }
  };

  /** 操作列 */
  const operateColumn = {
    key: 'processButton',
    title: '操作',
    width: 'auto',
    dragChecked: true,
    fixed: 'right',
    render: (value, record) => {
      const operateList = refactorPermissions(isArray(value) ? value.map(itm => ({ ...itm, event: itm.code })) : []);

      return !hideOperate && operateList.length ? (<V2Operate
        operateList={operateList}
        onClick={(btn: any) => methods[btn.func](btn, record)}
      />) : '-';
    }
  };

  /** 提供给拓店任务-森马使用的列 */
  const clusterSenmaColumns = [
    {
      key: 'basicProjectPhotos',
      title: '点位图片',
      width: 100,
      dragMinWidth: 100,
      dragChecked: false,
      noTooltip: true,
      render: (value) => <Image
        className={styles.img}
        src={value?.[0]?.url || 'https://staticres.linhuiba.com/project-custom/locationpc/task/ic_place_noimg.png'}
      />
    },
    {
      key: 'basicChancePointName',
      title: '点位名称',
      width: '118',
      importWidth: true,
      dragChecked: true,
      render: (value, record) => {
        return isNotEmptyAny(value) ? (
          <span
            // className={!isView ? styles.highlight : ''}
            className={hideOperate ? '' : styles.highlight}
            onClick={() => methods.onClickDetail(record)}
          >
            {value}
          </span>
        ) : (
          '-'
        );
      },
    },
    {
      key: 'basicAddress',
      title: '详细地址',
      width: 120,
      importWidth: true,
      dragChecked: true,
      render: (value) => isNotEmptyAny(value) ? value : '-',
    },
    { key: 'dailyPassengerFlowSemir', title: '单日过店客流(人)', width: 140, dragChecked: true, },
    { key: 'basicUsableArea', title: '面积(㎡)', width: 85, dragChecked: true, },
    { key: 'shopWidth', title: '门宽(m)', width: 75, dragChecked: true, },
    { key: 'monthlyrent', title: '租金', width: 95, importWidth: true, dragChecked: true, },
    { key: 'propertyfees', title: '物业费', width: 95, importWidth: true, dragChecked: true, },
    { key: 'checkBizDeductionPoint', title: '扣点', width: 75, importWidth: true, dragChecked: true, },
    { key: 'otherNotes', title: '其他', width: 120, importWidth: true, dragChecked: true, },
    operateColumn,
  ];
  const defaultColumns = tenantInfo && tenantInfo?.protectFlag ? [...basicColumns, protectColumn, operateColumn] : [...basicColumns, operateColumn];

  const tableColumns = providerFor === 'clusterC' ? clusterSenmaColumns : defaultColumns;

  const methods = useMethods({

    /** 点位评估 */
    handleEvaluationCreateApproved(item, record) {
      // 不走审批
      if (!enableSpotApproval) {
        methods.submitSemirEvaluation(item, record);
        return;
      }
      methods.submitApprovalEvaluation(item, record);
    },

    /** 点位评估（走审批） */
    async submitApprovalEvaluation(item, record) {
      if (isView || !item.isHighlight) return; // 审批详情时不可编辑，或者按钮不高亮的内容不可点击

      const res = await checkApprovalForm({
        type: item.approvalType,
        typeValue: item.approvalTypeValue,
        relationId: record.id
      });
      if (res) {
        // 必填校验通过的时候打开发起审批弹窗
        setApprovalModal({
          show: true,
          type: item.approvalType,
          typeValue: item.approvalTypeValue,
          id: record.id
        });
      } else {
        // 必填校验未通过
        V2Confirm({
          onSure: (modal: any) => {
            setDrawerData({
              open: true,
              templateId: '', // 模板id
              id: record.id, // 编辑时的id
              expandStoreData: item, // 拓店任务相关信息
            });
            modal.destroy();
          },
          okText: '去补充',
          title: '信息提示',
          content: `您的${chancepointAlias || '机会点'}暂未填写完整，请去补充${chancepointAlias}信息`
        });
      }
    },

    /** 点位评估（不走审批，如森马） */
    async submitSemirEvaluation(item, record) {
      if (isView) return; // 审批详情时不可编辑，或者按钮不高亮的内容不可点击

      const res = await checkApprovalForm({
        type: item.approvalType || ApprovalType.ShopEvaluation,
        typeValue: item.approvalTypeValue || ApprovalTypeValue.ShopEvaluation,
        relationId: record.id
      });
      if (res) {
        // 必填校验通过的时候，森马模板不走审批直接提交
        V2Confirm({
          onSure: async(modal: any) => {
            const passRes = await passStandardChancepoint({ id, chancePointId: record?.id, });
            if (passRes) {
              V2Message.success('提交成功');
              refresh();
              setFilters({});
              methods.closeApprovalModal();
            }
            modal.destroy();
          },
          content: `确认提交「点位评估」操作吗？`
        });
        return;
      } else {
        // 必填校验未通过
        V2Confirm({
          onSure: (modal: any) => {
            setDrawerData({
              open: true,
              templateId: '', // 模板id
              id: record.id, // 编辑时的id
              expandStoreData: item, // 拓店任务相关信息
            });
            modal.destroy();
          },
          okText: '去补充',
          title: '信息提示',
          content: `您的${chancepointAlias || '机会点'}暂未填写完整，请去补充${chancepointAlias}信息`
        });
      }
    },

    /** 合同签约 */
    handleContractCreateApproved(item, record) {
      const { approvalId, approvalStatus } = record?.contractApprovingInfo || {};
      if (approvalId && approvalStatus === ApprovalStatus.Untreated) {
        // 签约审批中
        setContractApprovalData({
          id: approvalId,
          open: true,
        });
      } else {
        // 还未生成审批，则允许发起审批，或直接签约通过
        setPointId(record.id);
        // setSignVisible(true);
        editRef.current.init(record.id, ShopEditType.Sign);
        bigdataFn('e85b86cd-7d3a-4b8e-948b-c18e341bac56', '拓店任务详情-签约', '点击了拓店任务详情-签约', { op_block: '拓店任务管理', op_event: ``, });
      }
    },

    /** 保护 */
    handleSubmitProtect(item, record) {
      setPointId(record.id);
      setAreaProtectOpen(true);
    },

    /** 解绑 */
    handleRelease(item, record) {
      setReleaseData({
        open: true,
        id: record.id,
      });
    },

    /** 编辑 */
    handleEdit(item, record) {
      setFormDrawerData({
        id: record.id,
        open: true,
        templateId: '',
      });
    },
    /** 表单内提交点位评估后续操作 */
    closeApprovalModal() {
      if (drawerData.open) {
        setDrawerData({
          open: false,
          templateId: '', // 模板id
          id: '', // 编辑时的id
          expandStoreData: null // 拓店任务相关信息
        });
      }
    },

    /**
     * @description 加载表格数据
     */
    loadData: async() => {
      if (!id) return;
      const data = await taskChancePointInfo({ id });

      const list = isArray(data.objectList) ? data.objectList.map(itm => {

        // 处理拓店任务-森马的列名数据
        if (providerFor === 'clusterC') {
          const senmaParams = methods.parseSenmaChancePointColumns(itm.columns || []);
          Object.assign(itm, senmaParams);
        }

        const hasReleaseBtn = !!itm.releaseButton && canManualRelease;
        if (!hasReleaseBtn) return itm;
        const releaseBtn = {
          'sort': null,
          'name': '取消关联',
          'approvalTypeValue': null,
          'approvalType': null,
          'approvalFlowId': null,
          'code': 'release',
          'isComplete': false,
          'isHighlight': true
        };

        return {
          ...itm,
          processButton: [...(itm.processButton || []), releaseBtn]
        };
      }) : [];
      setChancePointInfo(data);
      setIsLoading(false);
      return {
        dataSource: list,
        count: data?.totalNum > 0 ? data?.totalNum : 0,
      };
    },

    /** 处理拓店任务-森马的关联机会点的列数据 */
    parseSenmaChancePointColumns(columns: any[]) {
      const columnsMap: any = (Array.isArray(columns) ? columns : []).reduce((pre, cur) => {
        pre[cur.identification] = decodeTextValue(cur.controlType, cur.textValue);
        return pre;
      }, {});
      console.log('columnsMap', columnsMap);

      // 拼接值和单位
      const linkValueSuffix = (obj) => [obj?.value, obj?.suffix].filter(isNotEmpty).join('');

      return {
        basicProjectPhotos: columnsMap.basicProjectPhotos || null, // 点位图片
        basicChancePointName: columnsMap.basicChancePointName || null, // 点位名称
        basicAddress: columnsMap.basicAddress?.address || null, // 详细地址
        dailyPassengerFlowSemir: columnsMap.dailyPassengerFlowSemir?.value || null, // 单日过店客流
        basicUsableArea: columnsMap.basicUsableArea?.value || null, // 面积
        shopWidth: columnsMap.shopWidth?.value || null, // 门宽
        monthlyrent: linkValueSuffix(columnsMap.monthlyrent) || null, // 租金
        propertyfees: linkValueSuffix(columnsMap.propertyfees) || null, // 物业费
        checkBizDeductionPoint: linkValueSuffix(columnsMap.checkBizDeductionPoint) || null, // 扣点
        otherNotes: columnsMap.otherNotes || null, // 其他
      };
    },

    /**
     * @description 加载所有审批模板
     */
    loadApprovalTemplates() {
      approvalTemplateList().then((data: any) => {
        let enable = false;
        if (isArray(data) && data.length) {
          const targetData = data.find(itm => itm.typeValue === ApprovalTypeValue.ShopEvaluation);
          enable = !!targetData?.enable && !!targetData.approvalFlowId;
        }
        setEnableSpotApproval(enable);
      });
    },

    /**
     * @description 点击名称查看详情
     * @param record 当前选中点击某一行的数据
     */
    onClickDetail: (record) => {
      // if (isView) return;
      // hideOperate为true时，按钮其实会被隐藏，这里是兜底
      if (hideOperate) return;
      setPointId(record.id); // 机会点ID
      setShowPointDetail(true); // 显示弹窗
    },

    /** 打开详情页时的编辑表单的刷新详情页 */
    updateHandle: () => {
      const curVal = refreshDetail + 1;
      setRefreshDetail(curVal);
    },

    /**
     * @description 关联机会点/创建机会点
     */
    handleCreatePointMatching: () => {
      if (isAutoRelate) {
        /* 自动关联
          单一机会点模板：直接打开创建机会点抽屉
          多个机会点模板：展示选择模板弹框
        */
        templateList?.length === 1 ? setFormDrawerData && setFormDrawerData({
          templateId: templateList[0]?.value,
          open: true,
        }) : setSelectTemplateVisible(true);
        return;
      }
      // bigdataBtn('b3561739-7a76-5764-8013-7c0fcf77b2ca', '拓店任务', '关联机会点', `点击了关联机会点`);
      bigdataFn('7f86d97e-6ddc-403c-9980-2dc72c598dab', '拓店任务详情-关联机会点', '点击了拓店任务详情-关联机会点', { op_block: '拓店任务管理', op_event: ``, });

      // 手动关联，展示关联弹框
      setShowCreateModal(true);
    },

  });

  return (
    <>
      <div className={styles.pointMatching} >
        {/* <V2Title type='H2' text='匹配机会点情况' divider/> */}
        {!!showInnerAddButton && <span className={styles.addInfo} onClick={methods.handleCreatePointMatching}>+ {addText}</span>}
        <V2Table
          key={!!tenantInfo?.protectFlag} // 当key值不同的时候强制重新渲染table,获取新的表头项
          filters={filters}
          loading={false}
          rowKey='id'
          type='easy'
          pagination={false}
          defaultColumns={tableColumns}
          hideColumnPlaceholder={providerFor !== 'clusterC'}
          floorWidth='75'
          voluntarilyEmpty
          useResizable={providerFor === 'clusterC'}
          onFetch={methods.loadData}
          className={cs(chancePointInfo?.objectList?.length ? '' : styles.hide, 'mt-12')}
        />
        {/* loading结束且没数据才会显示空状态 */}
        { chancePointInfo?.objectList?.length || isLoading ? <></> : <V2Empty
          className='mt-100'
          customTip={!isView
            ? <Button onClick={methods.handleCreatePointMatching} type='primary'>{addText}</Button>
            : '暂无点位'}
        />
        }
      </div>

      {/* 匹配机会点 */}
      <CreatePointMatching
        ref={createPointMatchingRef}
        id={id}
        modelClusterId={modelClusterId}
        chancepointAlias={chancepointAlias}
        onlyApprovedChance={onlyApprovedChance}
        refresh={() => {
          refresh();
          setFilters({});
        }}
        open={showCreateModal}
        setOpen={setShowCreateModal}
        setFormDrawerData={setFormDrawerData}
      />

      {/* 模版选择框  */}
      <SelectTemplateModal
        setVisible={setSelectTemplateVisible}
        visible={selectTemplateVisible}
        chancepointAlias={chancepointAlias}
        setFormDrawerData={setFormDrawerData}
      />

      {/* 机会点详情 */}
      <ChancePointDetail
        pointId={pointId}
        detailVisible={showPointDetail}
        setDetailVisible={setShowPointDetail}
        setFormDrawerData={setFormDrawerData}
        chancepointAlias={chancepointAlias}
        // assignedData={assignedChanceData}
        refreshDetail={refreshDetail}
        formDrawerData={formDrawerData}
        updateHandle={methods.updateHandle}
        expansionTaskClusterId={modelClusterId}
        onSearch={() => {
          refresh();
          setFilters({});
          createPointMatchingRef?.current?.onLoad();
        }}
      />

      {/* 完善点位评估时打开机会点编辑弹窗 */}
      <ChanceCreateDrawer
        drawerData={drawerData}
        isExpandStoreTaskIn
        handleExpandStoreApproved={methods.handleEvaluationCreateApproved}
        onSearch={() => {
          refresh();
          setFilters({});
        }}
        update={() => {
          refresh();
          setFilters({});
        }}
        closeHandle={() =>
          setDrawerData({
            open: false,
            templateId: '', // 模板id
            id: '', // 编辑时的id
            expandStoreData: null, // 拓店任务相关信息
          })
        }
      />

      {/* 提交审批弹窗 */}
      <CreateSpotApproval
        refresh={() => {
          refresh();
          setFilters({});
          methods.closeApprovalModal();
        }} // 刷新
        approvalModal={approvalModal}
        setApprovalModal={setApprovalModal}
      />
      {/* 合同签约 */}
      <ShopEditDrawer ref={editRef} reload={() => {
        refresh();
        setFilters({});
      }}/>
      {/* <ContractSignModal visible={signVisible} setVisible={setSignVisible} id={pointId} onRefresh={() => {
        refresh();
        setFilters({});
      }}/> */}
      {/* 区域保护弹窗 */}
      <AreaProtectionDrawer
        id={pointId}
        open={areaProtectOpen}
        setOpen={setAreaProtectOpen}
        updateHandle={() => {
          refresh();
          setFilters({});
        }}
      />
      {/* 解除绑定弹窗 */}
      <ReleaseChance
        chancepointAlias={chancepointAlias}
        modalData={releaseData}
        setModalData={setReleaseData}
        refresh={() => {
          refresh();
          setFilters({});
        }}
      />
      {/* 审批详情抽屉 */}
      <ApproverDetailDrawer
        id={contractApprovalData?.id}
        open={contractApprovalData?.open} // 是否可见
        setOpen={(op) => {
          setContractApprovalData((state) => ({
            ...state,
            open: op,
          }));
        }}
        onRefresh={() => {
          refresh();
          setFilters({});
        }}
      />
    </>

  );
});

export default PointMatching;
